import React, { useContext, useEffect, useState } from 'react';
import { SearchContext } from './index';
import { useService } from '../../../hooks/useService';
import { formatApiObj } from '../../../helpers/auctions';
import { randomString } from '../../../helpers/string';
import { Loading } from '../../Loading';
import '../../../styles/components/TopContentBlock.less';

const CityTopContentBlock = ({loc}) => {
    const city = loc.split(', ')[0];
    const [showMore, setShowMore] = useState(false);
    const {
        searchState: {active_tab, search_obj},
        total_records,
        upcoming_total_records,
        makeApiObj,
    } = useContext(SearchContext);
    const num_auctions = active_tab === 'active' ? total_records : upcoming_total_records;
    const [{ data: {metrics}, loading }, fireGetMetrics] = useService();
    const num_expiring = metrics?.num_expiring;

    useEffect(() => {
        fireGetMetrics({
            url: `/services/reports/auction-metrics/${active_tab}/city/content`,
            params: {
                ...formatApiObj(makeApiObj(search_obj)),
                randStr: randomString(),
            },
        });
    }, [active_tab]);

    return (
        <div className="top-content-block">
            {loading ? <Loading /> : (
                <>
                    <div style={{maxHeight: showMore ? '' : '225px', overflow: 'hidden'}}>
                        <p>
                            StorageTreasures makes it easy to find and bid on abandoned storage units{' '}
                            in {loc}. With our live online auctions, you can easily find and win{' '}
                            the items you need at the best prices. There {num_auctions == 1 ? 'is' : 'are'} currently {num_auctions}{' '}{active_tab} auction{num_auctions == 1 ? '' : 's'} in {city}, based on your filters{active_tab === 'active' && num_expiring ? `, and ${num_expiring} ${num_expiring == 1 ? 'is' : 'are'} ending today. Don't wait, bid now!` : '.'}
                        </p>
                        <p>
                            <strong>Unlock hidden treasures</strong><br/>
                            StorageTreasures is the go-to source for storage auctions in {city}.{' '}
                            Our platform helps you quickly locate and bid on storage units near you so{' '}
                            that you can uncover the hidden treasures that lie within.
                        </p>
                        <p>
                            <strong>Bid on storage auctions</strong><br/>
                            With our live online auctions, you can bid on units from the comfort{' '}
                            of your home or on the go with your mobile phone. Our secure bidding process{' '}
                            ensures that your data is safe and protected and our website keeps you informed{' '}
                            on each auction bid.
                        </p>
                        {showMore && (
                            <p>
                                <strong>Storage Auctions in {city} made easy</strong><br/>
                                We understand that finding and bidding on storage unit auctions in {loc}{' '}
                                isn't always easy, so we've made it simple with an easy-to-use interface{' '}
                                that lets you quickly locate and place bids on abandoned self storage units{' '}
                                with minimal effort.
                            </p>
                        )}
                    </div>
                    {!showMore && (
                        <p className="read-more" onClick={() => setShowMore(true)}>Read more...</p>
                    )}
                </>
            )}
        </div>
    );
};

CityTopContentBlock.displayName = 'TopContentBlock';

export default CityTopContentBlock;